//@flow
import {
  RANKING_GET_REQUEST,
  RANKING_SET,
  RANKING_UNSET,
  RANKING_USER_SET,
  RANKING_USER_GET_REQUEST,
  RANKING_USER_PAGE_CHANGE,
  RANKING_USER_LOAD_REQUEST,
  RANKING_USER_LOAD_SET,
  GET_CAMPAIGN_TEAM_RANKING_REQUESTING,
  LOAD_CAMPAIGN_TEAM_RANKING_REQUESTING,
} from "./constants";

// utilisé ?
export const getRankingRequest = (payload: { clientId: String }) => {
  return {
    type: RANKING_GET_REQUEST,
    payload,
  };
};

// userId n'est pas utilisé dans le saga mais est envoyé à chaque fois
export const getUserRankingRequest = (payload: {
  userId: String;
  campaignId: String;
  page: number;
  limit: number;
}) => {
  return {
    type: RANKING_USER_GET_REQUEST,
    payload,
  };
};

// Appelé ? parce que cette fonction dépend de getRankingRequest, qui n'est je crois, jamais appelé ^^
export const setRanking = payload => {
  return {
    type: RANKING_SET,
    payload,
  };
};

export const setUserRanking = (
  payload: {
    _id: string;
    picture: string;
    firstName: string;
    lastName: string;
    points: number;
  }[],
) => {
  return {
    type: RANKING_USER_SET,
    payload,
  };
};

// utilisé ?
export const unsetRanking = () => {
  return {
    type: RANKING_UNSET,
  };
};

export const changeUserRankingPage = (payload: number) => {
  return {
    type: RANKING_USER_PAGE_CHANGE,
    payload,
  };
};

// userId et clientId ne sont pas utilisé dans le saga
export const loadUserRankingRequest = (payload: {
  campaignId: string;
  limit: number;
  page: number;
}) => {
  return {
    type: RANKING_USER_LOAD_REQUEST,
    payload,
  };
};

// je crois que c'est ca car tu récupère le ranking du user.
// mais du coup pourquoi ne pas utilisé le setUserRanking() ?
// A prioris ca concat l'existant et le nouveau userRanking
export const loadUserRanking = (
  payload: {
    _id: string;
    picture: string;
    firstName: string;
    lastName: string;
    points: number;
  }[],
) => {
  return {
    type: RANKING_USER_LOAD_SET,
    payload,
  };
};

export const getCampaignTeamRankingRequest = (payload: {
  campaignId: String;
  page: Number;
  limit: Number;
}) => {
  return {
    type: GET_CAMPAIGN_TEAM_RANKING_REQUESTING,
    payload,
  };
};

export const loadCampaignTeamRankingRequest = (payload: {
  campaignId: String;
  page: number;
  limit: Number;
}) => {
  return {
    type: LOAD_CAMPAIGN_TEAM_RANKING_REQUESTING,
    payload,
  };
};
